var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTechDark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.128 5.803H3.765a.848.848 0 0 0-.847.847v12.7c0 .467.38.847.847.847h23.363c.466 0 .846-.38.846-.846V6.65a.848.848 0 0 0-.846-.847zM20.32 22.824h-2.886v-1.14h-3.958v1.14h-2.885a.738.738 0 0 0-.743.743c0 .415.328.743.743.743h9.728a.738.738 0 0 0 .743-.743.749.749 0 0 0-.743-.743z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTechDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-tech-dark.03038a3aa6698e4518ff69598f495a9b.svg";